// extracted by mini-css-extract-plugin
export default {"user":"UserSearchWithinOrganisation_user__bbvaW","email":"UserSearchWithinOrganisation_email__v1YHL"};